// track the type of document we're currently capturing

import { createSlice } from "@reduxjs/toolkit";

export const currentlyCapturingSlice = createSlice({
  name: "currentlyCapturing",
  initialState: {
    value: null,
  },
  reducers: {
    update: (state, action) => {
      state.value = action.payload;
    },
    reset: (state) => {
      state.value = null;
    },
  },
});

export const { update, reset } = currentlyCapturingSlice.actions;

export default currentlyCapturingSlice.reducer;
